<template>
  <path
    d="M17 10.5002V7.00018C17 6.45018 16.55 6.00018 16 6.00018H4C3.45 6.00018 3 6.45018 3 7.00018V17.0002C3 17.5502 3.45 18.0002 4 18.0002H16C16.55 18.0002 17 17.5502 17 17.0002V13.5002L19.29 15.7902C19.92 16.4202 21 15.9702 21 15.0802V8.91018C21 8.02018 19.92 7.57018 19.29 8.20018L17 10.5002Z"
  />
</template>
